import { render } from "./VenueManagement.vue?vue&type=template&id=0f5ae18c"
import script from "./VenueManagement.vue?vue&type=script&lang=js"
export * from "./VenueManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__